var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-template',[_c('div',{staticClass:"mb-6 mt-4"},[_c('h1',{staticClass:"text-2xl font-semibold text-gray-900"},[_vm._v("Planning")]),_c('p',{staticClass:"text-sm text-gray-500"},[_vm._v(" Suivez vos plannings, interventions et chantiers en un coup d'œil. ")])]),_c(_vm.selectedComponent,{tag:"component",staticClass:"mt-2"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }